module.exports = __webpack_public_path__ + "static/media/Lib1.6af1a4e3.jpg";